import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class DomainLawFirms extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
		nickname: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.options.length = 0

		this.loading = true
		const res = await api.get('/api/law-firms')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				const hasTrial = option.thermometers_aggregate.aggregate.count > 0
				Object.assign(option, { loading: false, hasTrial: hasTrial })
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.form.nickname = ''
		this.modalLoading = false
	}

	openEdit(lawFirm) {
		this.form.id = lawFirm.id
		this.form.name = lawFirm.name
		this.form.nickname = lawFirm.nickname
		this.$bvModal.show('modal-edit-firm')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-firm')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const lawFirm = this.options.find(
					(lawFirm) => lawFirm.id === this.form.id,
				)

				const res = await api.post(
					'/api/law-firms/' + lawFirm.id,
					this.form,
				)
				if (res.ok) {
					lawFirm.name = this.form.name
					lawFirm.nickname = this.form.nickname
					this.$bvModal.hide('modal-edit-firm')
					this.$bvToast.toast('Escritório salvo com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const res = await api.post('/api/law-firms/', this.form)
				if (res.ok) {
					this.options.push({
						id: res.data.id,
						name: this.form.name,
						nickname: this.form.nickname,
						loading: false,
					})

					// @ts-ignore
					fuse = new Fuse(this.options, {
						keys: ['name'],
					})

					this.$bvModal.hide('modal-new-firm')
					this.$bvToast.toast('Escritório adicionado com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async deleteLawFirm(lawFirm, index) {
		const res = await api.delete('/api/law-firms/', lawFirm)
		if (res.ok) {
			this.options.splice(index, 1)
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast(
				'Escritório excluído com sucesso!',
				{
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				},
			)
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}

	mounted() {
		this.init()
	}
}
